// @ts-ignore
import loadGoogleMapsApi from 'load-google-maps-api-2'

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      loadGoogleMapsApi
    }
  }
})